import { ReactElement } from 'react';

import { Table, TableBody, TableContainer } from '@mui/material';

import { TableFlexOverflowContainer } from '@/components';

import { CreditsList } from './CreditsList';
import { CreditsPagination } from './CreditsPagination';
import { CreditsTableHead } from './CreditsTableHead';

export const CreditsTable = (): ReactElement => {
  return (
    <TableFlexOverflowContainer>
      <TableContainer>
        <Table stickyHeader>
          <CreditsTableHead />
          <TableBody>
            <CreditsList />
          </TableBody>
        </Table>
      </TableContainer>

      <CreditsPagination />
    </TableFlexOverflowContainer>
  );
};
